/**
 * Approve Modal Component
 * 
 * Modal for approving disputes
 * Creates group chat for arbitration
 */

import React, { useEffect } from 'react';
import {
  Box,
  Typography,
  Alert,
  Checkbox,
  FormControlLabel
} from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import BaseActionModal, { IActionModalProps, IModalChildProps } from './BaseActionModal';
import { ArbitrationAction } from '../../../services/arbitrationService';

interface ApproveModalProps extends Omit<IActionModalProps, 'action'> {
  disputeType: string;
}

const ApproveModalContent: React.FC<IModalChildProps & { disputeType: string }> = ({
  payload,
  setPayload,
  setIsValid,
  disputeType
}) => {
  const [confirmed, setConfirmed] = React.useState(false);

  useEffect(() => {
    setIsValid(confirmed);
  }, [confirmed, setIsValid]);

  return (
    <Box>
      <Alert severity="info" icon={<CheckCircleOutlineIcon />} sx={{ mb: 3 }}>
        <Typography variant="body2">
          با تأیید این اختلاف، یک چت گروهی برای داوری ایجاد می‌شود و به طرفین اطلاع‌رسانی خواهد شد.
        </Typography>
      </Alert>

      <Box sx={{ 
        p: 2, 
        bgcolor: 'success.50', 
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'success.200'
      }}>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          اقدامات پس از تأیید:
        </Typography>
        <Box component="ul" sx={{ m: 0, pl: 2 }}>
          <Typography component="li" variant="body2">
            ایجاد چت گروهی با خریدار و فروشنده
          </Typography>
          <Typography component="li" variant="body2">
            ارسال نوتیفیکیشن به همه طرفین
          </Typography>
          <Typography component="li" variant="body2">
            تغییر وضعیت اختلاف به "تأیید شده"
          </Typography>
        </Box>
      </Box>

      <FormControlLabel
        control={
          <Checkbox
            checked={confirmed}
            onChange={(e) => setConfirmed(e.target.checked)}
            color="success"
          />
        }
        label="من تأیید می‌کنم که این اختلاف نیاز به بررسی دارد"
        sx={{ mt: 2 }}
      />
    </Box>
  );
};

const ApproveModal: React.FC<ApproveModalProps> = ({ disputeType, ...props }) => {
  return (
    <BaseActionModal {...props} action={ArbitrationAction.APPROVE}>
      <ApproveModalContent disputeType={disputeType} payload={{}} setPayload={() => {}} isValid={false} setIsValid={() => {}} />
    </BaseActionModal>
  );
};

export default ApproveModal;

